<template>
    <div class="main bbt-main bg-gray" style="padding-top:24px;">
        <div class="bbt-container">
            <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                <div class="bbt-col-xs-5" style="padding-left: 12px; padding-right: 12px;">
                    <ul class="bbt-tab" @click="liChange">
                        <li class="active" data-module="infoModule">
                            <i class="el-icon-user"></i>基本信息
                        </li>
                        <li class="" data-module="safeModule">
                            <i class="layui-icon layui-icon-vercode"></i>安全设置
                        </li>
                        <!-- <li class="">
                            <i class="layui-icon layui-icon-link"></i>第三方绑定
                        </li> -->
                        <!-- <li class="" data-module="powerModule">
                            <i class="layui-icon layui-icon-password"></i>论坛权限
                        </li> -->
                        <li class="" data-module="liveCast"><i class="el-icon-warning-outline"></i>直播
                        </li>
                    </ul>
                </div>
                <div class="bbt-col-xs-19" style="padding-left: 12px; padding-right: 12px;">
                    <!-- 基本信息 -->
                    <div class="info-module" v-if="moduleItem === 'infoModule'">
                        <div class="info-module__header">
                            基本信息
                        </div>
                        <div class="info-module__body">
                            <div class="info-module__avatar bbt-clearfix">
                                <div class="info-module__upload">
                                    <img :src="headImg" alt="" class="bbt-avatar">
                                    <!-- <div class="upload-mask">
                                        <div class="file-ipt el-input">
                                            <input type="file" autocomplete="off" accept="image/gif,image/jpeg,image/jpg,image/png" class="el-input__inner">
                                        </div>
                                        <i class="bbt-icon bbt-icon-camera" style="font-size: 40px;"></i><br>
                                        修改头像
                                    </div> -->
                                </div>
                                <div class="info-module__username">
                                    <el-upload
                                        class="upload-demo"
                                        action="https://api.xianglaxiangla.com/api/v1/user/upload"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :limit="1"
                                        :show-file-list="false">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                                    </el-upload>
                                </div>
                            </div>
                            <form class="el-form">
                                <div class="el-form-item">
                                    <label for="display_name" class="el-form-item__label">昵称</label>
                                    <div class="el-form-item__content">
                                        <div class="el-input">
                                            <input type="text" autocomplete="off" :placeholder="user.username" class="el-input__inner" v-model="nickName">
                                        </div>
                                    </div>
                                </div>
                                <div class="el-form-item">
                                    <label for="desc" class="el-form-item__label">个人简介</label>
                                    <div class="el-form-item__content">
                                        <div class="el-textarea">
                                            <textarea autocomplete="off" v-model="descriptions" :placeholder="user.description == ''? '请输入个人简介' : user.description" class="el-textarea__inner" style="min-height: 33px;"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <button class="bbt-btn bbt-btn--primary bbt-btn-lg" @click="saveUserInfo">保存信息</button>
                        </div>
                        <div class="el-dialog__wrapper" style="display: none;">
                            <div role="dialog" aria-modal="true" aria-label="修改头像" class="el-dialog" style="margin-top: 15vh; width: 500px;">
                                <div class="el-dialog__header">
                                    <span class="el-dialog__title">修改头像</span>
                                </div>
                                <div class="el-dialog__footer">
                                    <span class="dialog-footer">
                                        <button class="bbt-btn bbt-btn--default bbt-btn-sm" style="margin-right: 16px;">取 消</button>
                                        <button class="bbt-btn bbt-btn--primary bbt-btn-sm">确 定</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 安全设置 -->
                    <div class="safe-module" v-else-if="moduleItem === 'safeModule'">
                        <div class="safe-module__header">安全设置</div>
                        <div class="safe-module__body">
                            <div class="safe-module__item">
                                <span class="label"><i class="layui-icon layui-icon-password" style="font-size: 22px;"></i>密码设置</span>
                                <span class="val">已设置密码</span>
                                <button type="button" class="bbt-btn bbt-btn-ghost--primary bbt-btn--lg" @click="dialogVisible = true">修改</button>
                                <el-dialog
                                    title="修改密码"
                                    :visible.sync="dialogVisible"
                                    width="30%"
                                    :before-close="handleClose">
                                    <!-- <span>这是一段信息</span>
                                    <span slot="footer" class="dialog-footer">
                                        <el-button @click="dialogVisible = false">取 消</el-button>
                                        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                                    </span> -->
                                    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                                        <el-form-item label="旧密码" prop="oldpass">
                                            <el-input type="password" v-model="ruleForm.oldpass" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item label="新密码" prop="pass">
                                            <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item label="确认新密码" prop="checkPass">
                                            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-dialog>
                            </div>
                            <!-- <div class="safe-module__item">
                                <span class="label"><i class="layui-icon layui-icon-cellphone" style="font-size: 22px;"></i>手机绑定</span>
                                <span class="val">已绑定，手机号码 185****3712</span>
                                <button class="bbt-btn bbt-btn-ghost--primary bbt-btn--lg">修改</button>
                            </div>
                            <div class="safe-module__item">
                                <span class="label"><i class="layui-icon layui-icon-release" style="font-size: 22px;"></i>邮箱绑定</span>
                                <span class="val">已绑定，邮箱地址 7699e5abca****@8btc.com</span>
                                <button class="bbt-btn bbt-btn-ghost--primary bbt-btn--lg">修改</button>
                            </div> -->
                        </div>
                        <div class="el-dialog__wrapper" style="display: none;">
                            <div role="dialog" aria-modal="true" aria-label="安全验证" class="el-dialog" style="margin-top: 15vh; width: 25%;">
                                <div class="el-dialog__header">
                                    <span class="el-dialog__title">安全验证</span>
                                </div>
                                <div class="el-dialog__footer">
                                    <div class="dialog-footer">
                                        <button class="bbt-btn bbt-btn--default bbt-btn-sm" style="margin-right: 16px;">取 消</button>
                                        <button class="bbt-btn bbt-btn--primary bbt-btn-sm">立即验证</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 论坛权限 -->
                    <!-- <div class="power-module" v-else-if="moduleItem === 'powerModule'">
                        <div class="power-module__header">
                            论坛权限
                        </div>
                        <div class="power-module__body">
                            <div class="power-module__item">
                                <span class="label">用户组</span>
                                <span class="val">水手</span>
                            </div>
                            <div class="power-module__item">
                                <span class="label">积分 <span>?</span></span>
                                <span class="val">0</span>
                            </div>
                            <div class="power-module__table">
                                <div class="power-module__th">
                                    <div style="width: 24%;">权限</div>
                                    <div style="width: 30%;">我的用户组 - 水手</div>
                                    <div style="width: 46%;">晋级用户组 - 船员</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">用户积分</div>
                                    <div style="width: 30%;"><span>积分：</span>0</div>
                                    <div style="width: 46%;"><span>您升级到此用户组还需积分 </span>100</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">用户级别</div>
                                    <div style="width: 30%;">水手</div>
                                    <div style="width: 46%;">船员</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">访问论坛</div>
                                    <div style="width: 30%;">是</div>
                                    <div style="width: 46%;">是</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">阅读权限</div>
                                    <div style="width: 30%;">10</div>
                                    <div style="width: 46%;">20</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">隐身</div>
                                    <div style="width: 30%;">否</div>
                                    <div style="width: 46%;">否</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">使用搜索</div>
                                    <div style="width: 30%;">95</div>
                                    <div style="width: 46%;">95</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">自定义头衔</div>
                                    <div style="width: 30%;">否</div>
                                    <div style="width: 46%;">否</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">发帖不受限制</div>
                                    <div style="width: 30%;">否</div>
                                    <div style="width: 46%;">否</div>
                                </div>
                                <div class="power-module__tr">
                                    <div style="width: 24%;">允许发送短消息</div>
                                    <div style="width: 30%;">是</div>
                                    <div style="width: 46%;">是</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- 直播 -->
                    <div class="power-module" v-else>
                        <div class="power-module__header">
                            直播
                        </div>
                        <div class="power-module__body">
                            <div id="playercontainer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'UserEdit',
    props:{
        serveHost: String
    },
    data() {
        var validateOldPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入旧密码'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if(value.trim().length < 6) {
                callback(new Error('密码至少6位'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            moduleItem:'infoModule',
            dialogVisible:false,
            nickName:'',
            descriptions:'',
            headImg: process.env.BASE_URL + '/default/avatar.webp',
            user:{},
            ruleForm: {
                oldpass:'',
                pass: '',
                checkPass: ''
            },
            rules: {
                oldpass: [
                    { validator: validateOldPass, trigger: 'blur' }
                ],
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        liChange:function(event) {
            this.moduleItem = event.target.dataset.module;
            $(event.target).attr('class', 'active').siblings().removeAttr('class')
        },
        handleAvatarSuccess:function(res, file) {
            this.headImg = file.response.data.src;
            this.user = JSON.parse(localStorage.user);
            this.user.avatar = file.response.data.src;
            localStorage.setItem('user', JSON.stringify(this.user));
        },
        beforeAvatarUpload:function(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt2M = file.size / 1024 < 500;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG或png 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return (isJPG || isPNG) && isLt2M;
        },
        saveUserInfo:function() {
            var _vm  = this;
            var user = this.user;
            this.$confirm('确定要保存吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(_=>{
                $.ajax({
                    type:'POST',
                    url:this.serveHost + '/api/v1/user/update/info',
                    data:{
                        userId:user.userid,
                        avatar:_vm.headImg,
                        nickName:_vm.nickName,
                        descriptions:_vm.descriptions
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        if(r.code === '2000000') {
                            user.avatar = _vm.headImg;
                            user.description = _vm.descriptions;
                            user.nickName = _vm.nickName;
                            localStorage.user = JSON.stringify(user);
                            _vm.$message({
                                message:'修改成功',
                                type:'success'
                            });
                            setTimeout(function(){
                                // 跳回到个人中心首页
                                _vm.$router.push({path:'/userDetail/' + user.userid + '/UserDetailPost'});
                            }, 1500);
                        } else {
                            _vm.$message.error('修改失败，请尝试重新登录！');
                        }
                    }
                });
            }).catch(_=>{
                _vm.headImg = process.env.BASE_URL + '/default/avatar.webp';
                _vm.nickName = '';
                _vm.descriptions = ''
            });
        },
        handleClose(done) {
            var _vm = this;
            this.$confirm('确认关闭？将会丢失填写的信息')
            .then(_ => {
                done();
                _vm.resetForm('ruleForm');
            })
            .catch(_ => {
            });
        },
        submitForm(formName) {
            var _vm = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    $.ajax({
                        type:'POST',
                        url:this.serveHost + '/api/v1/user/password/update',
                        data:{
                            oldPassword:this.ruleForm.oldpass,
                            newPassword:this.ruleForm.checkPass,
                            username:this.user.username,
                        },
                        headers:{
                            Authorization:localStorage.getItem('token')
                        },
                        success:function(r) {
                            if(r.code === '2000000') {
                                localStorage.removeItem('user');
                                _vm.user = {};
                                location.href = '/pages/userAction.html?t=l';
                            } else {
                                _vm.$message({
                                    message:r.msg,
                                    type:'error'
                                });
                            }
                            
                        },
                        error:function(r) {
                            // console.log(r);
                            _vm.$message({
                                message:r.msg,
                                type:'error'
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    created() {
        this.user = JSON.parse(localStorage.user);
        if(this.user.avatar == null) {
            this.headImg = 'https://bbtcdn.8btc.com/uc_server/images/noavatar_big.gif'
        } else {
            this.headImg = this.user.avatar;
        }
    },
    updated() {
        // DOM渲染结束再执行
        this.$nextTick(function() {
            var videosrc="rtmp://push.xianglaxiangla.com/stream/UmlnVHmKMetcc6IH";
            var player = cyberplayer("playercontainer").setup({
                width: 880,
                height: 580.8,
                file: videosrc, // <—rtmp直播地址
                autostart: true,
                stretching: "uniform",
                volume: 100,
                controls: true,
                rtmp: {
                    reconnecttime: 5, // rtmp直播的重连次数
                    bufferlength: 1 // 缓冲多少秒之后开始播放 默认1秒
                },
                ak: "05e2a01dfca9452a8c24e33b6aa79fee" // 公有云平台注册即可获得accessKey
            });
        })
    }
}
</script>

<style scoped>
.bbt-tab li:hover:not(.active) {
    color:#409EFF;
}
.power-module__tr>div {
    display: inline-block;
    float: left;
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    padding: 16px 20px;
    border-right: 1px solid #e8e8e8;
}
.power-module__th>div {
    display: inline-block;
    float: left;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    padding: 16px 20px;
    border-right: 1px solid #e8e8e8;
}
.power-module__tr {
    overflow: hidden;
}
.power-module__th {
    overflow: hidden;
    background: #f8f8f8;
    border-bottom: 1px solid rgba(0,0,0,.08);
}
.power-module__table {
    border: 1px solid rgba(0,0,0,.08);
    border-right: 0;
    border-radius: 4px;
    margin-top: 24px;
}
.power-module__item {
    padding: 25px 0;
    margin-top: 8px;
    border-bottom: 1px dashed rgba(0,0,0,.08);
    position: relative;
}
.power-module__header:before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    top: 18px;
    left: 24px;
    border-radius: 2px;
    background: #409EFF;
}
.power-module__body {
    padding: 0 24px 48px;
    min-height: 800px;
}
.power-module__header {
    padding: 16px 0 16px 36px;
    border-bottom: 1px solid rgba(0,0,0,.08);
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    position: relative;
}
.el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
    box-sizing: border-box;
}
.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}
.el-dialog .el-dialog__header {
    padding: 10px 0 0;
}
.el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
}
.safe-module__item>.label i {
    margin-right: 16px;
    font-weight: 400;
    vertical-align: top;
    position: relative;
    top: 3px;
}
.bbt-btn.bbt-btn-ghost--primary {
    color: #409EFF;
    border-color: #409EFF;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn-ghost--primary:hover{
    color: #fff;
    background-color:#409EFF;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.safe-module__item>.bbt-btn {
    float: right;
    margin-top: -8px;
}
.safe-module__item>.val {
    color: rgba(0,0,0,.56);
    margin: 0 40px;
    font-size: 12px;
    line-height: 22px;
}
.safe-module__item>.label {
    color: rgba(0,0,0,.88);
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
}
.safe-module__item {
    padding: 25px 0;
    margin-top: 8px;
    border-bottom: 1px dashed rgba(0,0,0,.08);
}
.safe-module__body {
    padding: 0 24px 48px;
    min-height: 500px;
}
.safe-module__header:before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    top: 18px;
    left: 24px;
    border-radius: 2px;
    background: #409EFF;
}
.safe-module__header {
    padding: 16px 0 16px 36px;
    border-bottom: 1px solid rgba(0,0,0,.08);
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    position: relative;
}
.safe-module {
    background: #fff;
}
.bbt-btn.bbt-btn--default {
    color: rgba(0,0,0,.88);
    background: #f1f1f1;
    border-color: #f1f1f1;
    transition: all .3s ease;
}
.el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
    box-sizing: border-box;
}
.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}
.el-dialog__title {
    color: rgba(0,0,0,.88);
    font-weight: 700;
}
.el-dialog .el-dialog__header {
    padding: 10px 0 0;
}
.el-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
}
.el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
}
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #409EFF;
    border-color: #409EFF;
    transition: all .3s ease;
}
.bbt-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    padding: 9px 15px;
    line-height: 1;
    border: 1px solid transparent;
    background: none;
    border-radius: 4px;
    outline: none;
}
.info-module__body .el-form-item .el-form-item__label {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    margin-bottom: 4px;
}
.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
}
.info-module__body .el-form-item .el-form-item {
    margin-bottom: 0;
}
.bbt-col-xs-8 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333333%;
}
.bbt-col-xs-16 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66666667%;
}
.info-module__body .el-form-item .el-input__inner {
    border: 0;
    box-shadow: inset 0 -1px 0 0 rgba(0,0,0,.08);
    padding: 8px 0;
    border-radius: 0;
    color: rgba(0,0,0,.88);
}
.el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
}
.el-form-item__content:after {
    clear: both;
}
.el-form-item__content:after, .el-form-item__content:before {
    display: table;
    content: "";
}
.el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
}
.info-module__body .el-form-item .el-form-item__label {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    margin-bottom: 4px;
}
.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
}
.info-module__body .el-form-item {
    margin-bottom: 32px;
}
.link-dark-major {
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}
.link-dark-major {
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}
.info-module__username p+p, .info-module__username p span {
    display: block;
    color: rgba(0,0,0,.56);
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
}
.info-module__username p {
    margin: 0;
}
.info-module__username {
    padding: 38px 0 38px 160px;
    color: rgba(0,0,0,.88);
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
}
.el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
}
.file-ipt, .file-ipt .el-input__inner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
}
.el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.file-ipt, .file-ipt .el-input__inner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
}
.file-ipt {
    opacity: 0;
    z-index: 2;
    cursor: pointer;
}
.info-module__upload .upload-mask {
    width: 128px;
    height: 128px;
    padding: 34px 0;
    background: rgba(0,0,0,.5);
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
}
.info-module__upload .bbt-avatar {
    width: 128px;
    height: 128px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
}
.bbt-avatar {
    border-radius: 50%;
    vertical-align: middle;
}
.info-module__upload {
    width: 128px;
    height: 128px;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    float: left;
    margin-bottom: 32px;
}
.info-module__body {
    padding: 40px 50px;
}
.info-module__header:before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    top: 18px;
    left: 24px;
    border-radius: 2px;
    background:#409EFF;
}
.info-module__header {
    padding: 16px 0 16px 36px;
    border-bottom: 1px solid rgba(0,0,0,.08);
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    position: relative;
}
.info-module {
    background: #fff;
}
.bbt-col-xs-19 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 79.16666667%;
}
ul li i {
    margin-right: 8px;
    font-weight: 400;
    font-size: 16px;
}
ul li+li {
    margin-top: 8px;
}
ul li.active {
    color: #fff;
    background: #409EFF;
}
ul li {
    padding: 8px 24px;
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    cursor: pointer;
    transition: all .3s ease;
}
ul {
    padding: 16px 0;
    list-style: none;
    background: #fff;
}
ul {
    padding: 0;
    margin: 0;
}
.bbt-col-xs-5 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20.83333333%;
}
.bbt-row:after {
    clear: both;
}
.bbt-row:after, .bbt-row:before {
    content: " ";
    display: table;
}
.bbt-container:after {
    clear: both;
}

.bbt-container:after, .bbt-container:before {
    display: table;
    content: "";
}
@media (min-width: 1200px){
    .bbt-container {
        width: 1200px;
    }
}
.bbt-container {
    padding-left: 12px;
    padding-right: 12px;
    margin: 0 auto;
}
.bbt-main {
    padding-bottom: 48px;
}
.bg-gray {
    background: #f8f8f8;
}
</style>